/* global femcare */

femcare.shared.accordionDefault = {
    init: function () {
        var $accordions = $('.accordion-standalone');
        if($accordions.length){
            femcare.general.accordion.init('.accordion--default', 'content');
        }
    }
};
